import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';

import { ChangeClusterDto, ChangeClusterStore, ClusterDto } from '../../../../../stores/configuration/machinery/clusters-store';
import { nameof } from '../../../../../utils/object';

interface ChangeClusterViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  changeCluster?: ChangeClusterStore;
  currentCluster: ClusterDto;
}

// tslint:disable-next-line:no-empty-interface
interface ChangeClusterViewState {}

@connect(['changeCluster', ChangeClusterStore])
class ChangeClusterView extends React.Component<ChangeClusterViewProps, ChangeClusterViewState> {
  private get changeClusterStore() {
    return this.props.changeCluster;
  }

  constructor(props: ChangeClusterViewProps) {
    super(props);

    this.changeClusterStore.state.result = null;

    this.changeClusterStore.change({
      id: this.props.currentCluster.id,
      name: this.props.currentCluster.name
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps: ChangeClusterViewProps) {
    if (this.changeClusterStore.state.result && this.changeClusterStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onChangeItem() {
    this.changeClusterStore.update();
  }

  @autobind
  private onCancelChangeItem() {
    this.changeClusterStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.changeClusterStore.change({ ...this.changeClusterStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelChangeItem} closeOnDimmerClick={false}>
        <Dimmer active={this.changeClusterStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('Edit Cluster')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.changeClusterStore.state.result && !this.changeClusterStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.changeClusterStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.changeClusterStore.state.item && (
              <Form>
                <Form.Field>
                  <Form.Input
                    required
                    fluid
                    label={t('Cluster')}
                    placeholder={t('Name')}
                    value={this.changeClusterStore.state.item.name}
                    onChange={(e, { value }) => this.handleValue(nameof<ChangeClusterDto>('name'), value)}
                  />
                </Form.Field>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button className="basic" onClick={this.onCancelChangeItem}>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onChangeItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(ChangeClusterView);
